var map = {
	"./cmn_msg_de.json": 1967,
	"./cmn_msg_en.json": 1968,
	"./cmn_msg_es.json": 1969,
	"./cmn_msg_fr.json": 1970,
	"./cmn_msg_ja.json": 1971,
	"./cmn_msg_pt.json": 1972,
	"./cmn_msg_zh.json": 1973
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1966;